import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-base-warning-modal',
    templateUrl: './base-warning-modal.component.html',
    styleUrls: ['./base-warning-modal.component.scss'],
    standalone: false
})
export class BaseWarningModalComponent implements OnInit {
  public message: string;
  public okBtnText: string;
  public cancelBtnText: string;
  public isLoading = false;

  public okBtnHandler = () => {
    this.dialogRef.close(true);
  }

  public cancelBtnHandler = () => {
  }

  constructor(
    public dialogRef: MatDialogRef<BaseWarningModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.message = this.data.message;
    this.okBtnText = this.data.okBtnText;
    this.cancelBtnText = this.data.cancelBtnText;
    this.okBtnHandler = this.data.okBtnHandler || this.okBtnHandler;
    this.cancelBtnHandler = this.data.cancelBtnHandler || this.cancelBtnHandler;
  }
}
